import Loadable from "vuetify/lib/mixins/loadable";
import Themeable from "vuetify/lib/mixins/themeable";
import { Crudable } from "kinnect-mixins";
import {
	KActionDialog,
	KCopyButton,
	KDataTableMenu,
	KLink
} from "kinnect-general";
import {
	VAlert,
	VCard,
	VCardTitle,
	VCol,
	VDataIterator,
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VRow,
	VListItemContent,
	VListItemSubtitle,
	VListItemTitle,
	VTooltip
} from "vuetify/lib";

export default VDataIterator.extend( {
	name: "KPricingHelpList",

	mixins: [
		Crudable,
		Loadable,
		Themeable
	],

	props: {
		sortBy: {
			...VDataIterator.options.props.sortBy,
			default: "name"
		}
	},

	data: () => ( {
		crud: "pricing_help"
	} ),

	methods: {
		deletePricingHelp( PricingHelp ) {
			const deleteIndex = this.items.findIndex( item => PricingHelp.id === item.id );

			return PricingHelp.delete().then( () => {
				this.$delete( this.items, deleteIndex );
			} );
		},

		genItem( item ) {
			return <VCol
				cols={12}
				sm={6}
				md={4}
				lg={3}
			>
				<VCard height="100%" outlined>
					<VCardTitle class="grey darken-4 white--text">
						<VRow align="center">
							<VCol class="text-subtitle-1 py-0">
								{item.name}
							</VCol>

							<KDataTableMenu>
								<VList>
									<VListItem to={{
										name: "pricingHelp",
										params: { idPricingHelp: item.id }
									}}>
										<VListItemAction>
											<VIcon>visibility</VIcon>
										</VListItemAction>

										<VListItemContent>
											<VListItemTitle>View</VListItemTitle>
										</VListItemContent>
									</VListItem>

									{this.canDelete && <KActionDialog
										confirmButtonColor="error"
										confirmButtonText="Delete"
										loading={this.$wait.is( "delete pricing help" )}
										onConfirm={() => this.deletePricingHelp( item )}
										scopedSlots={{
											activator: ( { on } ) =>
												<VListItem on={on}>
													<VListItemAction>
														<VIcon>delete</VIcon>
													</VListItemAction>

													<VListItemContent>
														<VListItemTitle>Delete</VListItemTitle>
													</VListItemContent>
												</VListItem>
										}}
										title="Delete Pricing Help"
									>
										Are you sure you want to delete the pricing help for <strong>{item.name}</strong>?
									</KActionDialog>}
								</VList>
							</KDataTableMenu>
						</VRow>
					</VCardTitle>

					<VList class="list--auto-height">
						{item.url && <VListItem>
							<VListItemContent>
								<VListItemTitle>Website</VListItemTitle>
								<VListItemSubtitle>
									<KLink
										href={item.url}
										icon="open_in_new"
										target="_blank"
									>Go to website</KLink>
								</VListItemSubtitle>
							</VListItemContent>
						</VListItem>}

						{item.fields.map( field =>
							<VListItem>
								<VListItemContent>
									<VListItemTitle>{field.name}</VListItemTitle>
									<VListItemSubtitle>
										<VRow align="center" noGutters>
											<VCol class="grow">{field.value}</VCol>

											<VTooltip
												bottom
												scopedSlots={{
													activator: ( { on } ) =>
														<KCopyButton
															class="shrink"
															on={on}
															small
															text
															value={field.value}
														></KCopyButton>
												}}
											>
												Copy {field.name} to clipboard
											</VTooltip>
										</VRow>
									</VListItemSubtitle>
								</VListItemContent>
							</VListItem>
						)}

						{item.fileUrl && <VListItem>
							<VListItemContent>
								<VListItemTitle>File</VListItemTitle>
								<VListItemSubtitle>
									<KLink
										href={item.fileUrl}
										icon="attach_file"
										target="_blank"
									>Pricing Help File</KLink>
								</VListItemSubtitle>
							</VListItemContent>
						</VListItem>}
					</VList>
				</VCard>
			</VCol>;
		},

		genItems( items ) {
			return <VRow>{items.map( this.genItem )}</VRow>;
		}
	},

	render() {
		return <VDataIterator
			attrs={{ ...this.$props }}
			on={{ ...this.$listeners }}
			scopedSlots={{
				default: ( { items } ) => this.genItems( items ),
				...this.$scopedSlots
			}}
		>
			<template slot="no-data">
				{this.genProgress()}

				<VAlert
					class={{
						"text-left ma-0 grey--text": true,
						"lighten-2 text--darken-2": !this.isDark,
						"darken-3 text--lighten-2": this.isDark
					}}
					color="grey"
					icon="info"
				>{this.loading ? "Loading..." : "No pricing help has been added yet"}</VAlert>
			</template>

			<VAlert
				class={{
					"text-left ma-0 grey--text": true,
					"lighten-2 text--darken-2": !this.isDark,
					"darken-3 text--lighten-2": this.isDark
				}}
				color="grey"
				icon="info"
				slot="no-results"
			>No matching pricing help found</VAlert>
		</VDataIterator>;
	}
} );
